module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_shibuya-88095434824fb4e9690ce8cbbc78fa15.jpg";